module.exports = __webpack_public_path__ + "img/nut-pecans-190x100.dd3d5b34.jpg";